import { render, staticRenderFns } from "./ProjectDetail.vue?vue&type=template&id=23c499c6&scoped=true"
import script from "./ProjectDetail.vue?vue&type=script&lang=js"
export * from "./ProjectDetail.vue?vue&type=script&lang=js"
import style0 from "./ProjectDetail.vue?vue&type=style&index=0&id=23c499c6&prod&lang=stylus&scoped=true"
import style1 from "./ProjectDetail.vue?vue&type=style&index=1&id=23c499c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c499c6",
  null
  
)

export default component.exports